import React, { useEffect, useRef, useState } from 'react';
import '../../styles/AllBoatsSection.css';

const BoatCategoryFilterModal = ({ onClose, onApply, selected, anchorRef }) => {
  const [selectedCategory, setSelectedCategory] = useState(selected);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const panelRef = useRef(null);

  // Cargar categorías al montar el componente
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/categories/`);
        if (response.ok) {
          const data = await response.json();
          // Filtrar categorías que tienen al menos 1 barco
          const categoriesWithBoats = data.filter(category => (category.boats_count || 0) > 0);
          setCategories(categoriesWithBoats);
        }
      } catch (error) {
        console.error('Error loading categories:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadCategories();
  }, []);

  // Cerrar al hacer click fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target) &&
        (!anchorRef || !anchorRef.current || !anchorRef.current.contains(event.target))
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose, anchorRef]);

  // Al seleccionar, aplicar y cerrar
  const handleSelect = (category) => {
    setSelectedCategory(category);
    onApply(category);
    onClose();
  };

  // Clear category filter
  const handleClearCategory = () => {
    setSelectedCategory(null);
    onApply(null);
    onClose();
  };

  if (loading) {
    return (
      <div className="boat-size-filter-dropdown-panel" ref={panelRef}>
        <div className="boat-size-filter-list">
          <div style={{ padding: '1em', textAlign: 'center' }}>Loading categories...</div>
        </div>
      </div>
    );
  }

  // Si no hay categorías con barcos, mostrar mensaje
  if (categories.length === 0) {
    return (
      <div className="boat-size-filter-dropdown-panel" ref={panelRef}>
        <div className="boat-size-filter-list">
          <div style={{ padding: '1em', textAlign: 'center', color: '#ccc' }}>
            No categories with boats available
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="boat-size-filter-dropdown-panel" ref={panelRef}>
      <div className="boat-size-filter-list">
        {/* Clear category option */}
        <button
          className={
            'boat-size-filter-btn' +
            (!selectedCategory ? ' boat-size-filter-btn--active' : '')
          }
          onClick={handleClearCategory}
          type="button"
        >
          All Categories
        </button>
        
        {/* Category options - only show categories with boats */}
        {categories.map(category => (
          <button
            key={category.id}
            className={
              'boat-size-filter-btn' +
              (selectedCategory && selectedCategory.id === category.id
                ? ' boat-size-filter-btn--active'
                : '')
            }
            onClick={() => handleSelect(category)}
            type="button"
          >
            {category.name} ({category.boats_count || 0})
          </button>
        ))}
      </div>
    </div>
  );
};

export default BoatCategoryFilterModal; 